import { SESSION_LENGTH } from "utils/env-management"

export const TIME_REQUEST_TIME_DURATION = `Длительность: ${SESSION_LENGTH} минут`
